import React, { Component } from "react";
import logo from "../../logo.png";
import UserStore from "../../stores/UserStore";
import Can from "../authentication/Can";
import { MenuItems } from "./MenuItems";
import { Link } from "react-router-dom";
import { observer } from "mobx-react";
import { Redirect } from "react-router-dom";
import { withRouter } from "react-router-dom";

class NavBar extends Component {
  state = { clicked: false };
  overUserCog = false;

  mouseOverUsersCog = () => {
    this.setState({ Boolean: this.overUserCog = true });
  };

  mouseLeaveUsersCog = () => {
    this.setState({ Boolean: this.overUserCog = false });
  };
   
  handleClick = () => {
    this.setState({ clicked: !this.state.clicked });
  };
  
  async doLogout() {
    this.setState({
      buttonDisabled: true,
    });
    try {
      let res = await fetch("/logout", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      let result = await res.json();

      if (result && result.success) {
        UserStore.isLoggedIn = false;
        UserStore.username = "";
        UserStore.permissions = [{ name: "visitor" }];
        this.props.history.push("/login");
      }
    } catch (e) {
      console.log(e);
    }
  }

  render() {
    return (
      <nav className="navBar-Items">
        <Link to="/">
          <img src={logo} className="navBar-Logo" alt="Renaissance" />
        </Link>
        <div className="menu-Icon" onClick={this.handleClick}>
          <i className={this.state.clicked ? "fas fa-times" : "fas fa-bars"} />
        </div>
        <ul className={this.state.clicked ? "nav-Menu active" : "nav-Menu"}>
          {MenuItems
            .filter(
              (item) =>
                (this.props.showATTCNBDNav || item.pageName !== "att-cnbd") &&
                (!UserStore.isLoggedIn || item.pageName !== "home")
            )
            .map((item, index) => {
            return (
              <Can
                key={index}
                role={UserStore.permissions}
                perform={item.pageName.concat(":visit")}
                yes={() => (
                  <Link style={{ textDecoration: "none" }} to={item.url}>
                    <li onClick={this.handleClick}>
                      <p className={item.cName}>{item.title}</p>
                    </li>
                  </Link>
                )}
              />
            );
          })}
        </ul>
        <div className="userIcon">
          <div
            onMouseEnter={()=> this.mouseOverUsersCog() }
            onMouseLeave={()=> this.mouseLeaveUsersCog() }
          >
            {UserStore.isLoggedIn ? (
              <><Link
                  className="userText"
                  style={{ textDecoration: "none" }}
                  to="/profile"
               >
                {" "}
                <i className="fas fa-users-cog" /> {UserStore.username}{""}
              </Link>
              <>
                  {" "}{this.overUserCog && (
                    <p><button className="btn" id="tinyBtn"
                      onClick={() => {this.doLogout(); return <Redirect to="/login"/>;}}
                    >Log Out</button></p>
                  )}
                  
                </></>       
            ) : (
              <Link
                className="userText"
                style={{ textDecoration: "none" }}
                to="/login"
              >
                {" "}
              <i className="fas fa-users-cog" /> {"Log In"}{" "}
              </Link>
            )}
          </div>           
        </div>
      </nav>
    );
  }
}

export default withRouter(observer(NavBar));
